import { useEffect } from "react";
import Clinics from "@/components/sections/Clinics";

export default function ClinicsPage() {
    useEffect(() => { document.title = "HearClear Clinics — Book a Styletto IX Trial Near You"; }, []);
    return (
        <>
            <section className="pt-24 pb-6 md:pt-36 md:pb-12">
                <div className="container-x max-w-[820px]">
                    <p className="eyebrow">HearClear Network</p>
                    <h1 className="font-serif text-[44px] md:text-[64px] leading-[1.04] mt-3">
                        40+ HearClear clinics. <span className="italic text-[#003E4D]">Expert care, near you.</span>
                    </h1>
                </div>
            </section>
            <Clinics />
        </>
    );
}
